export default __webpack_public_path__ + "static/media/register-slide-5.19ddf48a.jpg";